import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import ConceptosGastosCreate from "./ConceptosGastosCreate";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import ExportJsonExcel from "js-export-excel";
import { Search } from "../../../DataTable"; // ✅

function ListadoConceptosGastos() {
  const { user } = useContext(AuthContext);
  const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [idEdit, setIdEdit] = useState();
  const [search, setSearch] = useState(""); // ✅

  const toggle = () => setModal(!modal);
  const [t] = useTranslation("global");

  useEffect(() => {
    axios
      .get(URL_CONCEPTOS_GASTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setConceptosGastos(response.data);
      })
      .catch((err) => console.log(err));
  }, []);

  function editConcepto(event) {
    event.preventDefault();
    const URL_CONCEPTOS_GASTOS_EDIT = `${process.env.REACT_APP_URL_CONCEPTOS_GASTOS}/${idEdit}`;

    axios
      .patch(
        URL_CONCEPTOS_GASTOS_EDIT,
        { name },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        return axios.post(
          URL_LOGS,
          {
            tipo: "Editar Concepto",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      })
      .then(() => {
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error?.response?.data ?? error?.message}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name) {
    setName(name);
    setIdEdit(idEdit);
    toggle();
  }

  function excel() {
    const dataExcel = conceptosGastos.map((a) => ({
      ID: a._id,
      Name: a.name,
    }));

    const dataExcelLimpia = Object.values(dataExcel).filter((el) => el != null);

    var option = {};
    option.fileName = "ListadoConceptos";
    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoConceptos",
        sheetFilter: ["ID", "Name"],
        sheetHeader: ["ID", "Name"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        {user.menu_gastos ? (
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <h3 align="center">{t("Conceptos Gastos")}</h3>

                  {/* ✅ Search igual que en Proveedores */}
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                    }}
                  />

                  <Table size="sm" striped borderless className="table-responsive-xl">
                    <thead>
                      <tr>
                        <th className="tituloTabla">{t("Nombre")}</th>
                        <th className="tituloTabla">{t("Editar")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {conceptosGastos
                        .filter((c) => {
                          const q = (search || "").trim().toLowerCase();
                          if (!q) return true;

                          const nombre = (c?.name || "").toLowerCase();
                          return nombre.includes(q);
                        })
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => (
                          <tr key={a._id}>
                            <td>{a.name}</td>
                            <td>
                              <Button
                                color="info"
                                id="Editar"
                                size="sm"
                                onClick={() => jalaInfo(a._id, a.name)}
                              >
                                <i className="far fa-edit"></i>
                              </Button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <ConceptosGastosCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t("Editar Conceptos Gastos")}</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">{t("Nombre")}</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editConcepto}>
            {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoConceptosGastos;
